/**
 * @license Copyright (c) 2014-2021, CKSource - Frederico Knabben.
 */

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';

// 기본 필수 플러그인들
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard.js';

// 텍스트 스타일링
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code.js';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';

// 폰트 관련
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize.js';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';

// 정렬 및 레이아웃
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';

// 제목 및 블록
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';

// 목록
import List from '@ckeditor/ckeditor5-list/src/list.js';

// 링크
import Link from '@ckeditor/ckeditor5-link/src/link.js';

// 이미지
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';

// 테이블
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';

// 미디어
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

// 업로드 및 클라우드
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder.js';
import CKFinderUploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices.js';

// 자동화 기능
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';

class Editor extends ClassicEditor {}

// 실제로 설치된 플러그인들만 포함
Editor.builtinPlugins = [
  // 기본 필수
  Essentials,
  Paragraph,
  Clipboard,

  // 텍스트 스타일링
  Bold,
  Italic,
  Strikethrough,
  Underline,
  Code,
  Subscript,
  Superscript,

  // 폰트
  FontSize,
  FontFamily,
  FontColor,
  FontBackgroundColor,

  // 정렬 및 레이아웃
  Alignment,
  Indent,

  // 제목 및 블록
  Heading,
  BlockQuote,

  // 목록
  List,

  // 링크
  Link,

  // 이미지
  Image,
  ImageCaption,
  ImageStyle,
  ImageToolbar,
  ImageUpload,

  // 테이블
  Table,
  TableToolbar,

  // 미디어
  MediaEmbed,

  // 업로드
  CKFinder,
  CKFinderUploadAdapter,
  CloudServices,

  // 자동화
  Autoformat,
  PasteFromOffice,
  TextTransformation
];

// 설치된 기능들만 포함한 에디터 설정
Editor.defaultConfig = {
  language: 'ko',
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'code',
      'subscript',
      'superscript',
      '|',
      'fontSize',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'outdent',
      'indent',
      '|',
      'link',
      'imageUpload',
      'insertTable',
      'mediaEmbed',
      '|',
      'blockQuote'
    ],
    shouldNotGroupWhenFull: true
  },
  image: {
    toolbar: [
      'imageStyle:full',
      'imageStyle:side',
      '|',
      'toggleImageCaption',
      'imageTextAlternative'
    ]
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells'
    ]
  },
  mediaEmbed: {
    previewsInData: true
  }
};

export default Editor;